
export let lunarUtil = function () {
	this.lunarInfo=new Array(//阴历数据
		0x04bd8,0x04ae0,0x0a570,0x054d5,0x0d260,0x0d950,0x16554,0x056a0,0x09ad0,0x055d2,
		0x04ae0,0x0a5b6,0x0a4d0,0x0d250,0x1d255,0x0b540,0x0d6a0,0x0ada2,0x095b0,0x14977,
		0x04970,0x0a4b0,0x0b4b5,0x06a50,0x06d40,0x1ab54,0x02b60,0x09570,0x052f2,0x04970,
		0x06566,0x0d4a0,0x0ea50,0x06e95,0x05ad0,0x02b60,0x186e3,0x092e0,0x1c8d7,0x0c950,
		0x0d4a0,0x1d8a6,0x0b550,0x056a0,0x1a5b4,0x025d0,0x092d0,0x0d2b2,0x0a950,0x0b557,
		0x06ca0,0x0b550,0x15355,0x04da0,0x0a5d0,0x14573,0x052d0,0x0a9a8,0x0e950,0x06aa0,
		0x0aea6,0x0ab50,0x04b60,0x0aae4,0x0a570,0x05260,0x0f263,0x0d950,0x05b57,0x056a0,
		0x096d0,0x04dd5,0x04ad0,0x0a4d0,0x0d4d4,0x0d250,0x0d558,0x0b540,0x0b5a0,0x195a6,
		0x095b0,0x049b0,0x0a974,0x0a4b0,0x0b27a,0x06a50,0x06d40,0x0af46,0x0ab60,0x09570,
		0x04af5,0x04970,0x064b0,0x074a3,0x0ea50,0x06b58,0x055c0,0x0ab60,0x096d5,0x092e0,
		0x0c960,0x0d954,0x0d4a0,0x0da50,0x07552,0x056a0,0x0abb7,0x025d0,0x092d0,0x0cab5,
		0x0a950,0x0b4a0,0x0baa4,0x0ad50,0x055d9,0x04ba0,0x0a5b0,0x15176,0x052b0,0x0a930,
		0x07954,0x06aa0,0x0ad50,0x05b52,0x04b60,0x0a6e6,0x0a4e0,0x0d260,0x0ea65,0x0d530,
		0x05aa0,0x076a3,0x096d0,0x04bd7,0x04ad0,0x0a4d0,0x1d0b6,0x0d250,0x0d520,0x0dd45,
		0x0b5a0,0x056d0,0x055b2,0x049b0,0x0a577,0x0a4b0,0x0aa50,0x1b255,0x06d20,0x0ada0
	);

	this.day_gan=new Array("甲","乙","丙","丁","戊","己","庚","辛","壬","癸");
	this.day_zhi=new Array("子","丑","寅","卯","辰","巳","午","未","申","酉","戌","亥");

	//返回农历第y年的总天数
	this.lunar_day  = function(y) {
	   var i, sum = 348;
	   for(i=0x8000; i>0x8; i>>=1) sum += (this.lunarInfo[y-1900] & i)? 1: 0;
	   return(sum+this.lunar_leap(y));
	}

	//返回农历第y年闰月的天数
	this.lunar_leap = function(y) {
	   if(this.lunar_leap_m(y))  return((this.lunarInfo[y-1900] & 0x10000)? 30: 29);
	   else return(0);
	}

	//返回农历第y年闰几月（1-12月），没闰返回0
	this.lunar_leap_m = function(y) {
	   return(this.lunarInfo[y-1900] & 0xf);
	}

	//返回农历第y年第m月的总天数
	this.lunar_leap_d = function(y,m) {
	   return( (this.lunarInfo[y-1900] & (0x10000>>m))? 30: 29 );
	}

	//算出农历，把值传入到日期控件，返回农历日期控件
	//该农历日期对象的属性：.year,.month,.day,.isLeap,
	//.yearCyl,.monthCyl,.dayCyl
	this.toLunar = function (objDate) {
		var i, leap=0, temp=0;
		var baseDate = new Date(1900,0,31);
		var offset   = Math.floor((objDate - baseDate)/86400000);
		var dayCyl = offset + 40;
		var monCyl = 14;

		for(i=1900; i<2050 && offset>0; i++) {
			temp = this.lunar_day(i);
			offset -= temp;
			monCyl += 12;
		}

		if(offset<0) {
			offset += temp;
			i--;
			monCyl -= 12;
		}

		var year = i;
		var yearCyl = i-1864;

		leap = this.lunar_leap_m(i);
		var isLeap = false;

		for(i=1; i<13 && offset>0; i++) {
		   if(leap>0 && i==(leap+1) && isLeap==false)
				{ --i; isLeap = true; temp = this.lunar_leap(year); }
			else
				{ temp = this.lunar_leap_d(year, i); }

			if(isLeap==true && i==(leap+1)) isLeap = false;

			offset -= temp;
			if(isLeap == false) monCyl ++;
		}

		if(offset==0 && leap>0 && i==leap+1)
			if(isLeap)
				{ isLeap = false; }
			else
				{ isLeap = true; --i; --monCyl;}

		if(offset<0){ offset += temp; --i; --monCyl; }

		var month = i;
		var day = offset + 1;

		return {year:year,month:month,day:day,yearCyl:yearCyl,monCyl:monCyl,dayCyl:dayCyl}
	}

	//甲子年份计算
	this.toJiaZiYear = function(n){
		if(n){
			var years = ['甲子','乙丑','丙寅','丁卯','戊辰','己巳','庚午','辛未','壬申','癸酉','甲戌','乙亥','丙子','丁丑','戊寅','己卯','庚辰','辛己','壬午','癸未','甲申','乙酉','丙戌','丁亥','戊子','己丑','庚寅','辛卯','壬辰','癸巳','甲午','乙未','丙申','丁酉','戊戌','己亥','庚子','辛丑','壬寅','癸丑','甲辰','乙巳','丙午','丁未','戊申','己酉','庚戌','辛亥','壬子','癸丑','甲寅','乙卯','丙辰','丁巳','戊午','己未','庚申','辛酉','壬戌','癸亥'];
			return years[n%60-4]+"年 ";
		}
		return "";
	}

	this.year2Zh = function(y){
		var str = ["0","一","二","三","四","五","六","七","八","九"];
		return str[y.charAt(0)]+str[y.charAt(1)]+str[y.charAt(2)]+str[y.charAt(3)];
	}

	this.month2Zh = function (m){
		var arr = ["正","二","三","四","五","六","七","八","九","十","十一","十二"];
		return arr[parseInt(m)-1]+"月";
	}

	this.day2Zh = function (d){
		var arr = ["一","二","三","四","五","六","七","八","九","十"];
		if(parseInt(d) <= 9){
			return "初"+arr[parseInt(d)]+"日";
		}else if(parseInt(d) > 9 && parseInt(d) < 19){
			return "十"+arr[d-10]+"日";
		}else if(parseInt(d) == 19){
			return "廿日";
		}else if(parseInt(d) > 19 && parseInt(d) < 29){
			return "廿"+arr[d-20]+"日";
		}else if(parseInt(d) == 29){
			return "卅日";
		}else if(parseInt(d) == 30){
			return "卅一日";
		}
	}

	this.num2Zh = function (d){
		var arr = ["一","二","三","四","五","六","七","八","九","十"];
		if(parseInt(d) <= 10){
			return arr[parseInt(d)-1];
		}else if(parseInt(d) > 10 && parseInt(d) < 20){
			return "十"+arr[d-11];
		}else if(parseInt(d) == 20){
			return "廿";
		}else if(parseInt(d) > 20 && parseInt(d) < 30){
			return "廿"+arr[d-21];
		}else if(parseInt(d) == 30){
			return "卅";
		}else if(parseInt(d) > 30 && parseInt(d) < 40){
			return "卅"+arr[d-21];
		}else if(parseInt(d) == 40){
			return "卌";
		}else if(parseInt(d) > 40 && parseInt(d) < 50){
			return "卌"+arr[d-21];
		}else if(parseInt(d) == 50){
			return "圩";
		}else if(parseInt(d) > 50 && parseInt(d) < 60){
			return "圩"+arr[d-21];
		}else if(parseInt(d) == 60){
			return "圆";
		}else if(parseInt(d) > 60 && parseInt(d) < 70){
			return "圆"+arr[d-21];
		}else if(parseInt(d) == 70){
			return "进";
		}else if(parseInt(d) > 70 && parseInt(d) < 80){
			return "进"+arr[d-21];
		}else if(parseInt(d) == 80){
			return "枯";
		}else if(parseInt(d) > 80 && parseInt(d) < 90){
			return "枯"+arr[d-21];
		}else{
			return d;
		}
		
	}

	this.date2lunar = function (date,day,hours,calendar,leep_month){
		var cont = "";
		if(date){
			cont = date;
		}else if(day){
			cont = this.birthday2Zh(day, hours, calendar, leep_month);
			cont = cont!=""?("公元"+cont):"";
		}
		return cont;
	}

	this.year2Ch = function (str,start,end){
		var cont = "";
		if(str){
			cont = str;
		}else{
			let startStr = start?(this.year2Zh(start.split('-')[0])+"年"):"";
			let endStr = end?(this.year2Zh(end.split("-")[0])+"年"):"";
			if(startStr != "" && endStr != ""){
				cont = "公元"+startStr + " 至 " + endStr;
			}else if(startStr != ""){
				cont = "公元"+startStr;
			}else if(endStr != ""){
				cont = "公元"+endStr;
			}
		}
		return cont;
	}

	this.birthday2Zh = function (birthday, hours, calendar, leep){
		if(!birthday){
			return "";
		}
		var cont = "";
		var arr = birthday.split(" ")[0].split("-");
		
		if(calendar == "L"){// 阴历
			cont = this.year2Zh(arr[0]);
			cont += " "+this.cyclical(arr[0]-1864)+"年";
			cont += leep?"闰":"";
			cont += this.month2Zh(arr[1]);
			cont += this.day2Zh(arr[2]-1)+" ";
			cont += hours?hours:"";
		}else{
			var solor_dobj = new Date(arr[0], parseInt(arr[1]), parseInt(arr[2]));
			var lunar_dobj = this.toLunar(solor_dobj);
			cont = this.year2Zh(arr[0]);
			cont += " "+this.cyclical(lunar_dobj.yearCyl)+"年";
			cont += lunar_dobj.isLeap?"闰":"";
			cont += this.month2Zh(lunar_dobj.month-1);
			cont += this.day2Zh(lunar_dobj.day)+" ";
			cont += hours?hours:"";
			
		}
		return cont;
	}

	//传入offset 传回干支，0=甲子
	this.cyclical = function(num) {
		return(this.day_gan[num%10]+this.day_zhi[num%12]);
	}

}
		


// WEBPACK FOOTER //
// ./src/utils/lunar.js